"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestPreferencesEditorResponseDto = instanceOfDigestPreferencesEditorResponseDto;
exports.DigestPreferencesEditorResponseDtoFromJSON = DigestPreferencesEditorResponseDtoFromJSON;
exports.DigestPreferencesEditorResponseDtoFromJSONTyped = DigestPreferencesEditorResponseDtoFromJSONTyped;
exports.DigestPreferencesEditorResponseDtoToJSON = DigestPreferencesEditorResponseDtoToJSON;
exports.DigestPreferencesEditorResponseDtoToJSONTyped = DigestPreferencesEditorResponseDtoToJSONTyped;
/**
 * Check if a given object implements the DigestPreferencesEditorResponseDto interface.
 */
function instanceOfDigestPreferencesEditorResponseDto(value) {
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('selectedSports' in value) || value['selectedSports'] === undefined)
        return false;
    if (!('sportAnswers' in value) || value['sportAnswers'] === undefined)
        return false;
    if (!('sportsNeedingSetup' in value) || value['sportsNeedingSetup'] === undefined)
        return false;
    return true;
}
function DigestPreferencesEditorResponseDtoFromJSON(json) {
    return DigestPreferencesEditorResponseDtoFromJSONTyped(json, false);
}
function DigestPreferencesEditorResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayName': json['displayName'],
        'selectedSports': json['selectedSports'],
        'sportAnswers': json['sportAnswers'],
        'sportsNeedingSetup': json['sportsNeedingSetup'],
    };
}
function DigestPreferencesEditorResponseDtoToJSON(json) {
    return DigestPreferencesEditorResponseDtoToJSONTyped(json, false);
}
function DigestPreferencesEditorResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'displayName': value['displayName'],
        'selectedSports': value['selectedSports'],
        'sportAnswers': value['sportAnswers'],
        'sportsNeedingSetup': value['sportsNeedingSetup'],
    };
}
